// apps/web/src/components/landing-v2/proofs/AstroProof.tsx
/** Theme 02 / Today's astrological weather — pill + three glyph rows.
 *  Reference: handoff .mm-astro. */
const ROWS = [
  { glyph: '☽', label: 'Moon',    val: 'Pisces · waxing' },
  { glyph: '☉', label: 'Sun',     val: 'Scorpio · 22°' },
  { glyph: '☿', label: 'Mercury', val: 'Direct, finally' },
]

export function AstroProof() {
  return (
    <div className="absolute inset-0 flex flex-col p-[18px]">
      <span className="inline-flex w-fit items-center rounded-pill border border-astral-violet/30 bg-astral-violet/[0.16] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-astral-violet-light">
        Today&apos;s weather
      </span>
      <h4
        className="mt-2 font-display italic text-text-primary"
        style={{ fontSize: '0.95rem' }}
      >
        A slow, patient sky.
      </h4>
      <div className="mt-2 flex flex-col gap-1.5">
        {ROWS.map((r) => (
          <div
            key={r.label}
            className="flex items-center justify-between rounded-lg px-2.5 py-2 text-[12px]"
            style={{ background: 'var(--hairline-faint)' }}
          >
            <span className="flex items-center gap-1">
              <span
                className="mr-2 inline-flex h-[22px] w-[22px] items-center justify-center rounded-full font-display"
                style={{
                  background: 'color-mix(in oklab, var(--color-astral-violet) 18%, transparent)',
                  color: 'var(--color-astral-violet-light)',
                  fontSize: '0.9rem',
                }}
              >
                {r.glyph}
              </span>
              <span
                className="text-text-muted"
                style={{ letterSpacing: '0.06em' }}
              >
                {r.label}
              </span>
            </span>
            <span className="font-display italic text-text-primary">{r.val}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
